import { addDays, format, parseISO, startOfWeek } from 'date-fns';

/**
 * Week helpers for the planner (2026-09-07, "Start weeks on Monday").
 *
 * Weekly priorities and weekly wins are stored in Mongo under
 * `week_key = 'yyyy-MM-dd'` of the SUNDAY that starts the week — that key is
 * canonical and never changes with the display preference, so existing
 * documents, the quarterly review and any other client keep working. The
 * preference (`weekStartsOn`: 0 = Sunday, 1 = Monday) only changes which
 * seven days a "week" shows and which canonical key a date maps to: the
 * Sunday-based week that contains the display week's first day.
 */

export const WEEK_START_SUNDAY = 0;
export const WEEK_START_MONDAY = 1;

/** 'sunday' | 'monday' (server value) → 0 | 1 (date-fns weekStartsOn). */
export function weekStartsOnFrom(pref) {
  return pref === 'monday' ? WEEK_START_MONDAY : WEEK_START_SUNDAY;
}

/** First day of the DISPLAY week containing `date`. */
export function displayWeekStart(date, weekStartsOn = WEEK_START_SUNDAY) {
  return startOfWeek(date, { weekStartsOn });
}

/** Canonical (Sunday-based) storage key for the display week containing `date`. */
export function weekKeyFor(date, weekStartsOn = WEEK_START_SUNDAY) {
  const first = displayWeekStart(date, weekStartsOn);
  return format(startOfWeek(first, { weekStartsOn: WEEK_START_SUNDAY }), 'yyyy-MM-dd');
}

export function nextWeekKey(key) {
  return format(addDays(parseISO(key), 7), 'yyyy-MM-dd');
}

export function prevWeekKey(key) {
  return format(addDays(parseISO(key), -7), 'yyyy-MM-dd');
}

/** The date to LABEL a stored week with ("Week of …"): Monday-start users see the Monday. */
export function weekLabelDate(key, weekStartsOn = WEEK_START_SUNDAY) {
  return addDays(parseISO(key), weekStartsOn === WEEK_START_MONDAY ? 1 : 0);
}
